// extracted by mini-css-extract-plugin
module.exports = {"text-link":"Link_text-link__2eumO","text-link--with-padding":"Link_text-link--with-padding__l5AMO","f-12":"Link_f-12__Gs5bQ"};